import { div } from '|>/shared/h'
import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './tap-seek-animation.css'

@register
export class TapSeekAnimation extends BaseComponent {
  override createEl() {
    return div(
      '.vjs-x-tap-seek-animation',
      null,
      div('.vjs-x-tap-seek-background', null)
    )
  }
}
